<div class="poi-info-window">
  <h5 class="fw-bold">{{poi?.name}}</h5>
  <p class="font-size-15">{{poi?.street}}</p>
  <p class="font-size-15">{{poi?.zip}} {{poi?.city}}</p>
  <app-result-list-deadline [poi]="poi" class="mt-3"></app-result-list-deadline>
</div>